import { useMemo } from "react";

import TableCellLink from "ds/components/Table/Row/CellLink";
import TableSimpleCell from "ds/components/TableSimple/Cell";
import { TableSimpleCellProps } from "ds/components/TableSimple/types";
import useTypedContext from "hooks/useTypedContext";
import { StackContext } from "views/Stack/Context";
import { StackTaskRun } from "shared/Stack/useSearchTasks/gql";

import { STACK_TASKS_COLUMN_ID } from "../constants";
import useCellCopyAction from "../useCellCopyAction";

const StackTasksTableCommandCell = ({
  item: task,
  ...cellProps
}: TableSimpleCellProps<StackTaskRun>) => {
  const { stack } = useTypedContext(StackContext);

  const copyAction = useCellCopyAction({
    column: STACK_TASKS_COLUMN_ID.COMMAND,
    text: task.command ?? "",
  });

  const actions = useMemo(
    () => (task.command ? [copyAction] : undefined),
    [copyAction, task.command]
  );

  return (
    <TableSimpleCell {...cellProps} role="rowheader" actions={actions}>
      <TableCellLink href={`/stack/${stack.id}/run/${task.id}`}>{task.command}</TableCellLink>
    </TableSimpleCell>
  );
};

export default StackTasksTableCommandCell;
